window._ = require('lodash');
window.BASE_URL = `${location.protocol}//${location.host}`;

import 'bootstrap';
import {createApp, h} from "vue";
import {createInertiaApp, Link, Head} from "@inertiajs/inertia-vue3";
import {InertiaProgress} from "@inertiajs/progress";
import axios from "axios";
import VueAxios from "vue-axios";
import MasonryWall from "@yeger/vue-masonry-wall";
import Layout from "./Shared/Layout";
import "masonry-layout";

createInertiaApp({
    resolve: name => {
        let page = require(`./Pages/${name}`).default;

        if (page.layout === undefined) {
            page.layout = Layout;
        }

        return page;
    },

    setup({el, App, props, plugin}) {
        let app = createApp({render: () => h(App, props)})
            .use(plugin)
            .use(VueAxios, axios)
            .component("MasonryWall",MasonryWall)
            .component("Link", Link)
            .component("Head", Head)
            .mount(el);
    },

    title: title => `PSArtistsManagement - ${title}`,
});

InertiaProgress.init({
    color: "#00e600",
    showSpinner: true,
});
